import React from "react";

const Popup = ({ toggleConfirmPopup, checkout }) => {
  return (
    <>
      <div className="right-0 top-0 absolute bg-black bg-opacity-75 w-screen h-screen z-50 flex items-center justify-center">
        <div
          className="w-[80%] lg:w-[50%] rounded-2xl border border-blue-100 bg-white p-4 shadow-lg sm:p-6 lg:p-8"
          role="alert"
        >
          <div className="flex items-center gap-4">
            <span className="shrink-0 rounded-full bg-yellow-500 p-2 text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-5 h-5"
              >
                <path
                  fillRule="evenodd"
                  d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
            <p className="font-medium sm:text-lg">Confirm</p>
          </div>
          <p className="mt-4 text-gray-500">
            Before proceeding to checkout, just checking you remembered to enter
            a message for your gift recipient?
          </p>
          <div className="mt-6 sm:flex sm:gap-4">
            <button
              className="inline-block w-full rounded-lg bg-[#294870] px-5 py-3 text-center text-sm font-semibold text-white sm:w-auto"
              onClick={checkout}
            >
              Confirm & Continue to checkout
            </button>
            <button
              onClick={toggleConfirmPopup}
              className="mt-2 inline-block w-full rounded-lg bg-gray-50 px-5 py-3 text-center text-sm font-semibold text-gray-500 sm:mt-0 sm:w-auto"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Popup;
